import { StyleProp, ViewStyle } from 'react-native';

export { PhoneNumberMaskInput } from './phone-number-masked-input';
export { EmailInput } from './email-masked-input';
export { NameInput } from './name-input';
export { NumberMaskInput } from './number-masked-input';

export type MaskInputProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  onSubmitEditing?: () => void;
  error?: string;
  autoFocus?: boolean;
  readOnly?: boolean;
  name?: string;
  style?: StyleProp<ViewStyle>;
  required?: boolean;
};
